// Add class to page body tag if page is search listing page
let searchPage = document.querySelector('.searchListingPage');
if (searchPage) {
    document.body.classList.add('search');
}